import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state() {
    return {
      registInfo: JSON.parse(sessionStorage.getItem('registInfo')) || {},
      cardInfo: {},
      formData: JSON.parse(sessionStorage.getItem('formData')) || {},
      cpmDetail: {},
      deleteCardStatus: false,
    };
  },
  mutations,
  actions,
  getters,
  namespaced: true,
};
